import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MdbSvg = function MdbSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#prefix__a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#881421",
        d: "M6 15v5c0 1.38 3.694 2.5 8.25 2.5 4.557 0 8.25-1.12 8.25-2.5v-5z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#AF2031",
        d: "M6 9.5V15c0 1.38 3.694 2.5 8.25 2.5 4.557 0 8.25-1.12 8.25-2.5V9.5z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C94F60",
        d: "M6 4v5.5c0 1.38 3.694 2.5 8.25 2.5 4.557 0 8.25-1.12 8.25-2.5V4z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E08095",
        d: "M14.25 6.5c4.556 0 8.25-1.12 8.25-2.5s-3.694-2.5-8.25-2.5S6 2.62 6 4s3.694 2.5 8.25 2.5"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M12.084 6H6v12.5h6.084a.92.92 0 0 0 .916-.916V6.917A.92.92 0 0 0 12.084 6",
        opacity: 0.1
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M11.584 6.5H6V19h5.584a.92.92 0 0 0 .916-.916V7.417a.92.92 0 0 0-.916-.917",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M11.584 6.5H6V18h5.584a.92.92 0 0 0 .916-.916V7.417a.92.92 0 0 0-.916-.917",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M11.084 6.5H6V18h5.084a.92.92 0 0 0 .916-.916V7.417a.92.92 0 0 0-.916-.917",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#prefix__b)",
        d: "M11.084 6.5H1.917A.916.916 0 0 0 1 7.417v9.167c0 .506.41.916.917.916h9.167c.506 0 .916-.41.916-.916V7.417a.916.916 0 0 0-.916-.917"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M5.841 9.02h1.35l2.17 5.959H8.084l-.478-1.421H5.376l-.47 1.421H3.64zm1.48 3.62-.694-2.157a3 3 0 0 1-.127-.486h-.025q-.04.256-.125.5l-.7 2.144z"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__b",
        x1: 2.911,
        x2: 10.089,
        y1: 5.784,
        y2: 18.216,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#B72C3F"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.5,
          stopColor: "#B12334"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#9D1623"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "prefix__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })]
    })]
  });
};
export var Mdb = function Mdb(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: MdbSvg
  }));
};